exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#tags-select .multiselect {\n  width: calc(100% - 10px);\n  min-height: 0;\n}\n", ""]);

// exports
